
import { Vue, Component } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
@Component
export default class MasterClassList extends Vue {
  folderConfig: any = {
    className: "masterClassFolder",
    rootFolder: "mainFolder",
  };

  dataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 15,
    },
    className: "masterclass",
  });

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Мастер-классы",
        disabled: true,
      },
    ];
  }
}
